/**
 * Mail dashboard translations
 */

export const mail = {
  types: {
    mailbox: 'Postfach',
    alias: 'Alias',
    list: 'Mailingliste',
    shared: 'Geteiltes Postfach'
  },

  domainSection: {
    provision: {
      title: 'E-Mail aktivieren',
      description: 'Aktiviere E-Mail-Funktionen für diese Domain',
      button: 'E-Mail aktivieren',
      provisioning: 'Wird aktiviert...',
      success: 'E-Mail wurde aktiviert',
      error: 'E-Mail konnte nicht aktiviert werden'
    },
    verify: {
      title: 'Domain bestätigen',
      description:
        'Die Domain ist nicht bei uns registriert. Lege den TXT-Eintrag _itsh-mail aus der Liste oben bei deinem DNS-Anbieter an, damit wir sehen, dass sie dir gehört. Danach richten wir E-Mail ein.',
      button: 'Jetzt prüfen',
      verifying: 'Wird geprüft...',
      success: 'Domain bestätigt',
      missing:
        'Der TXT-Eintrag ist noch nicht zu finden. Neue DNS-Einträge brauchen manchmal etwas Zeit, wir prüfen auch automatisch alle zehn Minuten.',
      lookupFailed: 'Die DNS-Abfrage ist fehlgeschlagen. Bitte versuche es gleich noch einmal.',
      error: 'Domain konnte nicht bestätigt werden'
    },
    dns: {
      autoConfigure: 'Automatisch konfigurieren',
      success: 'DNS-Einträge wurden konfiguriert',
      error: 'DNS-Einträge konnten nicht konfiguriert werden'
    },
    dkim: {
      copied: 'DKIM-Schlüssel kopiert'
    },
    catchall: {
      title: 'Catch-All',
      description: 'Alle E-Mails an nicht existierende Adressen weiterleiten',
      enabled: 'Catch-All ist aktiviert',
      disabled: 'Catch-All ist deaktiviert',
      target: 'Ziel-Adresse',
      selectMailbox: 'Ziel-Postfach auswählen',
      noMailboxes: 'Für diese Domain existiert noch kein Postfach — lege zuerst eines an.',
      save: 'Speichern',
      disable: 'Deaktivieren',
      enable: 'Aktivieren',
      saving: 'Wird gespeichert...',
      success: 'Catch-All wurde aktualisiert',
      error: 'Catch-All konnte nicht aktualisiert werden'
    },
    stats: {
      title: 'Statistiken',
      period: {
        day: 'Heute',
        week: 'Diese Woche',
        month: 'Dieser Monat'
      },
      messagesIn: 'Empfangen',
      messagesOut: 'Gesendet',
      spamRejected: 'Spam abgelehnt',
      bytesIn: 'Empfangen',
      bytesOut: 'Gesendet'
    },
    subdomains: {
      title: 'Mail-Subdomains',
      subtitle: 'E-Mail für Subdomains aktivieren',
      add: 'Subdomain hinzufügen',
      empty: 'Keine Mail-Subdomains konfiguriert',
      table: {
        name: 'Name',
        fullName: 'Vollständig',
        dnsStatus: 'DNS-Status',
        created: 'Erstellt',
        actions: 'Aktionen'
      },
      dnsStatus: {
        configured: 'Konfiguriert',
        missing: 'Fehlt',
        partial: 'Teilweise'
      },
      provision: {
        title: 'Subdomain hinzufügen',
        nameLabel: 'Subdomain-Name',
        namePlaceholder: 'support',
        preview: 'Vorschau',
        reservedWarning: 'Einige Namen sind reserviert (www, mail, smtp, imap, pop, ftp, ns, mx, webmail, autodiscover, autoconfig)',
        button: 'Erstellen',
        success: 'Mail-Subdomain wurde erstellt',
        error: 'Mail-Subdomain konnte nicht erstellt werden',
        dkimHint: 'Dieser DKIM-Schlüssel muss als DNS-Eintrag konfiguriert werden.'
      },
      detail: {
        subtitle: 'Mail-Subdomain konfigurieren',
        dns: {
          title: 'DNS-Einträge',
          success: 'DNS-Einträge wurden konfiguriert',
          error: 'DNS-Einträge konnten nicht konfiguriert werden'
        },
        catchall: {
          title: 'Catch-All',
          selectMailbox: 'Ziel-Postfach auswählen',
          save: 'Speichern',
          success: 'Catch-All wurde aktualisiert',
          error: 'Catch-All konnte nicht aktualisiert werden'
        }
      },
      deprovision: {
        title: 'Mail-Subdomain entfernen',
        confirm: 'Möchtest du die E-Mail-Funktion für diese Subdomain wirklich deaktivieren?',
        warning: 'Stelle sicher, dass alle E-Mail-Konten auf dieser Subdomain gelöscht wurden.',
        button: 'Entfernen',
        success: 'Mail-Subdomain wurde entfernt',
        error: 'Mail-Subdomain konnte nicht entfernt werden'
      },
      errors: {
        invalidName: 'Ungültiger Subdomain-Name. Nur Kleinbuchstaben, Zahlen und Bindestriche erlaubt.',
        reservedName: 'Dieser Name ist reserviert und kann nicht verwendet werden.',
        alreadyProvisioned: 'Diese Subdomain ist bereits für E-Mail aktiviert.',
        hasMailAccounts: 'Diese Subdomain hat noch E-Mail-Konten. Lösche diese zuerst.',
        nameTaken:
          'Diese Subdomain ist schon als eigene Domain eingetragen und kann nicht zusätzlich Mail-Subdomain werden. Wende dich bei Fragen an den Support.'
      }
    }
  },

  dnsSetup: {
    progress: '{done} von {total} Pflicht-Einträgen erledigt',
    todo: 'Diese Einträge braucht deine Domain, damit E-Mails ankommen und nicht im Spam landen.',
    allDone: 'Alles eingerichtet',
    allDoneText: 'Deine Domain kann E-Mails senden und empfangen.',
    autoConfigureHint: 'Deine Domain nutzt unsere Nameserver. Wir können die fehlenden Einträge mit einem Klick für dich eintragen.',
    intro: 'Trage diese Einträge in der DNS-Verwaltung deiner Domain ein. Die findest du meist bei dem Anbieter, bei dem du die Domain gekauft hast.',
    propagation: 'Neue Einträge können bis zu einer Stunde brauchen, bis sie hier als gültig erscheinen.',
    recheck: 'Jetzt prüfen',
    required: 'Pflicht-Einträge',
    optional: {
      title: 'Optional: Einrichtung in Mail-Programmen',
      description: 'Diese Einträge brauchst du nicht zum Senden und Empfangen. Sie helfen Mail-Programmen, die richtigen Einstellungen selbst zu finden.',
      count: '{done} von {total} gültig'
    },
    state: {
      ok: 'Gültig',
      wrong: 'Stimmt nicht',
      missing: 'Fehlt',
      unknown: 'Nicht prüfbar'
    },
    fields: {
      type: 'Typ',
      name: 'Name/Host',
      priority: 'Priorität',
      weight: 'Gewichtung',
      port: 'Port',
      target: 'Ziel',
      value: 'Wert'
    },
    copy: {
      label: '{field} kopieren',
      title: '{field} kopiert',
      message: 'Füge den Wert jetzt bei deinem DNS-Anbieter ein.'
    },
    hints: {
      fullName: 'Vollständiger Name: {host}',
      apex: "{'@'} steht für die Domain selbst. Manche Anbieter wollen hier stattdessen ein leeres Feld.",
      trailingDot: 'Manche Anbieter brauchen am Ende einen Punkt: {example}',
      srvFields: 'Hat dein Anbieter getrennte Felder für Dienst und Protokoll? Dann trage {service} und {protocol} getrennt ein.',
      unknown: 'Wir konnten diesen Eintrag gerade nicht prüfen. Versuche es später noch einmal mit „Jetzt prüfen“.'
    },
    pitfalls: {
      mx: 'Hattest du vorher einen anderen E-Mail-Anbieter? Lösche dessen MX-Einträge, sonst landen E-Mails weiter dort.',
      spf: 'Gibt es schon einen Eintrag, der mit v=spf1 beginnt? Dann füge dort {part} genau so vor seinem all ein (zum Beispiel vor ~all), statt einen zweiten anzulegen. Mit zwei solchen Einträgen gilt keiner.',
      dmarc: 'Gibt es unter _dmarc schon einen Eintrag? Dann ersetze ihn durch diesen. Mit zwei DMARC-Einträgen gilt keiner.'
    },
    found: 'Bei deinem Anbieter gefunden',
    reasons: {
      duplicate: 'Hier stehen mehrere Einträge dieser Art, es darf aber nur einen geben. Behalte nur den Eintrag mit dem Wert oben und lösche die anderen.',
      duplicateSuggested: 'Diese Einträge heben sich gegenseitig auf. Lösche sie alle und lege stattdessen nur diesen einen an. Er fasst deine Einträge zusammen und enthält zusätzlich unsere Angaben. Weichen ihre DMARC-Policies voneinander ab, gilt die strengste.',
      extraMx: 'Neben unserem Mailserver sind noch andere eingetragen. Lösche die anderen, sonst landen E-Mails weiter dort.',
      mismatch: 'Der Eintrag hat einen anderen Wert. Ersetze ihn durch den Wert oben.',
      mismatchSuggested: 'Ersetze deinen Eintrag durch diesen. Er behält deine Einstellungen und enthält zusätzlich unsere Angaben.',
      spfMismatch: 'Dein SPF-Eintrag erlaubt unseren Server noch nicht. Füge {part} genau so vor seinem all ein (zum Beispiel vor ~all). Steht es schon dahinter, zählt es nicht: Verschiebe es nach vorn. Lege keinen zweiten SPF-Eintrag an.',
      spfDuplicate: 'Wir konnten diese SPF-Einträge nicht automatisch zusammenführen. Fasse sie selbst zu einem einzigen SPF-Eintrag zusammen: Übernimm die Mechanismen aus allen (etwa include: oder ip4:), füge {part} hinzu und lösche danach die anderen. Behältst du nur einen davon, dürfen die Absender aus den übrigen nicht mehr für deine Domain senden.',
      dkimDuplicate: 'Unter diesem Namen stehen mehrere Schlüssel. Lösche alle außer dem oben angezeigten.',
      cname: 'Dieser Name verweist per CNAME auf einen anderen Namen. Entferne den CNAME, damit unser Eintrag gilt.',
      dmarcCname: 'Dieser Name verweist per CNAME auf einen anderen Namen, oft einen Dienst für DMARC-Berichte. Entferne den CNAME. Oder sorge dafür, dass der Eintrag dort auch unsere Bericht-Adresse {address} enthält.'
    },
    errors: {
      partial: 'Einige Einträge konnten nicht eingetragen werden. Die Karten zeigen, was angekommen ist. Versuche es gleich noch einmal.',
      busy: 'Für diese Domain läuft gerade schon eine automatische Einrichtung. Warte einen Moment und prüfe dann erneut.',
      rateLimited: 'Zu viele Anfragen in kurzer Zeit. Warte eine Minute und versuche es dann noch einmal.',
      transferPending: 'Der Transfer dieser Domain ist noch nicht abgeschlossen, deshalb ist die automatische Einrichtung noch nicht möglich. Trage die Einträge bis dahin bei deinem bisherigen DNS-Anbieter ein.'
    },
    purpose: {
      mx: {
        title: 'E-Mails empfangen',
        description: 'Sagt anderen Servern, wohin sie E-Mails für deine Domain schicken sollen.'
      },
      spf: {
        title: 'Absender erlauben (SPF)',
        description: 'Erlaubt unserem Server, E-Mails für deine Domain zu verschicken. Ohne diesen Eintrag landen sie oft im Spam.'
      },
      dkim: {
        title: 'Mails signieren (DKIM)',
        description: 'Enthält den Schlüssel, mit dem Empfänger prüfen, dass eine E-Mail wirklich von deiner Domain kommt.'
      },
      dmarc: {
        title: 'Schutz vor Fälschungen (DMARC)',
        description: 'Sagt Empfängern, was sie mit gefälschten E-Mails in deinem Namen tun sollen.'
      },
      autoconfig: {
        title: 'Automatische Einrichtung (Thunderbird & Co.)',
        description: 'Hilft Thunderbird und anderen Mail-Programmen, die Server-Einstellungen selbst zu finden.'
      },
      autodiscover: {
        title: 'Automatische Einrichtung (Outlook)',
        description: 'Hilft Outlook, die Server-Einstellungen selbst zu finden.'
      },
      srv_autodiscover: {
        title: 'Automatische Einrichtung (Outlook)',
        description: 'Ein weiterer Weg für Outlook, die Server-Einstellungen zu finden.'
      },
      srv_imaps: {
        title: 'Postfach abrufen (IMAP)',
        description: 'Sagt Mail-Programmen, wo sie deine E-Mails abrufen.'
      },
      srv_submission: {
        title: 'Mails senden (SMTP)',
        description: 'Sagt Mail-Programmen, über welchen Server sie deine E-Mails verschicken.'
      },
      verify: {
        title: 'Bestätigung der Domain',
        description: 'Zeigt uns, dass dir die Domain gehört. Erst danach richten wir E-Mail für sie ein.'
      },
      generic: {
        title: '{type}-Eintrag',
        description: 'Wird für E-Mail auf deiner Domain gebraucht.'
      }
    }
  },

  accounts: {
    title: 'E-Mail-Konten',
    subtitle: 'E-Mail-Konten und Aliase verwalten',
    add: 'Konto erstellen',
    search: 'Suchen...',
    filter: {
      all: 'Alle',
      mailbox: 'Postfächer',
      alias: 'Aliase',
      list: 'Listen',
      shared: 'Geteilt'
    },
    table: {
      email: 'E-Mail',
      type: 'Typ',
      usage: 'Speicher',
      status: 'Status',
      actions: 'Aktionen'
    },
    status: {
      active: 'Aktiv',
      inactive: 'Inaktiv'
    },
    actions: {
      edit: 'Bearbeiten',
      viewDetails: 'Details anzeigen',
      delete: 'Löschen',
      toggleActive: 'Status ändern'
    },
    empty: {
      title: 'Keine E-Mail-Konten',
      description: 'Erstelle ein neues E-Mail-Konto um loszulegen.'
    },
    deleteModal: {
      title: 'Konto löschen',
      message: 'Bist du sicher, dass du {email} löschen möchtest? Diese Aktion kann nicht rückgängig gemacht werden.',
      confirmLabel: 'E-Mail-Adresse eingeben',
      confirmPlaceholder: 'E-Mail eingeben zur Bestätigung',
      cancel: 'Abbrechen',
      delete: 'Löschen',
      deleting: 'Wird gelöscht...',
      success: 'Konto wurde gelöscht',
      error: 'Konto konnte nicht gelöscht werden'
    }
  },

  createModal: {
    title: 'E-Mail-Konto erstellen',
    tabs: {
      mailbox: 'Postfach',
      alias: 'Alias',
      list: 'Mailingliste',
      shared: 'Geteilt'
    },
    fields: {
      name: 'Name',
      namePlaceholder: 'benutzer',
      domain: 'Domain',
      password: 'Passwort',
      passwordPlaceholder: 'Passwort eingeben',
      confirmPassword: 'Passwort bestätigen',
      confirmPasswordPlaceholder: 'Passwort wiederholen',
      generatePassword: 'Generieren',
      quota: 'Speicherplatz',
      quotaPresets: {
        1: '1 GB',
        5: '5 GB',
        10: '10 GB',
        25: '25 GB',
        50: '50 GB',
        100: '100 GB'
      },
      targets: 'Ziel-Adressen',
      targetsPlaceholder: 'E-Mail-Adresse eingeben und Enter drücken',
      targetsHint: 'Adressen an die dieser Alias weiterleitet',
      members: 'Mitglieder',
      membersPlaceholder: 'E-Mail-Adresse eingeben und Enter drücken',
      membersHint: 'Interne Postfächer die Mitglied dieser Liste sind',
      externalMembers: 'Externe Mitglieder',
      externalMembersPlaceholder: 'Externe E-Mail-Adresse eingeben',
      externalMembersHint: 'Externe E-Mail-Adressen die auch Mitglied sind',
      senderAddresses: 'Absender-Adressen',
      senderAddressesPlaceholder: 'Zusätzliche Absenderadresse',
      senderAddressesHint: 'Weitere Adressen von denen gesendet werden kann'
    },
    descriptions: {
      mailbox: 'Ein vollwertiges E-Mail-Postfach mit IMAP/SMTP-Zugang.',
      alias: 'Leitet E-Mails an eine oder mehrere Zieladressen weiter.',
      list: 'Verteiler für Gruppen-E-Mails an mehrere Empfänger.',
      shared: 'Geteiltes Postfach auf das mehrere Benutzer zugreifen können.'
    },
    validation: {
      nameRequired: 'Name ist erforderlich',
      nameInvalid: 'Nur Buchstaben, Zahlen, Punkte und Bindestriche erlaubt',
      domainRequired: 'Domain ist erforderlich',
      passwordRequired: 'Passwort ist erforderlich',
      passwordWeak: 'Passwort ist zu schwach',
      passwordMismatch: 'Passwörter stimmen nicht überein',
      targetsRequired: 'Mindestens eine Ziel-Adresse erforderlich',
      membersRequired: 'Mindestens ein Mitglied erforderlich',
      emailInvalid: 'Ungültige E-Mail-Adresse'
    },
    cancel: 'Abbrechen',
    create: 'Erstellen',
    creating: 'Wird erstellt...',
    success: 'E-Mail-Konto wurde erstellt',
    error: 'E-Mail-Konto konnte nicht erstellt werden'
  },

  detail: {
    title: 'Postfach',
    back: 'Zurück',
    tabs: {
      overview: 'Übersicht',
      filters: 'Filter',
      vacation: 'Abwesenheit',
      identities: 'Identitäten',
      appPasswords: 'App-Passwörter',
      history: 'Anmeldeverlauf'
    },
    overview: {
      title: 'Übersicht',
      email: 'E-Mail-Adresse',
      type: 'Typ',
      status: 'Status',
      created: 'Erstellt',
      lastLogin: 'Letzte Anmeldung',
      never: 'Nie',
      quota: {
        title: 'Speicherplatz',
        used: 'Verwendet',
        of: 'von',
        free: 'frei'
      },
      connection: {
        title: 'Verbindungseinstellungen',
        imap: 'IMAP',
        smtp: 'SMTP',
        server: 'Server',
        port: 'Port',
        security: 'Sicherheit',
        username: 'Benutzername',
        password: 'Passwort',
        autoconfig: {
          title: 'Automatische Einrichtung',
          intro:
            'Die meisten E-Mail-Programme finden die Server-Einstellungen automatisch, sobald du deine E-Mail-Adresse und das Passwort eingibst.',
          appleButton: 'Apple Mail Profil herunterladen',
          appleHint:
            'Auf iPhone, iPad oder Mac in Safari öffnen. Beim Installieren erscheint eine Warnung „Nicht signiert" – das ist normal, das Profil ist trotzdem sicher.',
          thunderbird: 'Thunderbird',
          thunderbirdNote: 'Funktioniert automatisch – nur E-Mail-Adresse und Passwort eingeben.',
          outlook: 'Outlook (Windows / Mac)',
          outlookNote:
            'Funktioniert automatisch. Beim ersten Einrichten zeigt Outlook einmalig „Diese Website darf Server-Einstellungen konfigurieren? https://autodiscover.itsh.dev" – auf „Zulassen" klicken.',
          other: 'Android (K-9, FairEmail, Thunderbird für Android)',
          otherNote: 'Funktioniert automatisch – nur E-Mail-Adresse und Passwort eingeben.'
        }
      },
      password: {
        title: 'Passwort ändern',
        current: 'Aktuelles Passwort',
        new: 'Neues Passwort',
        confirm: 'Passwort bestätigen',
        change: 'Passwort ändern',
        changing: 'Wird geändert...',
        success: 'Passwort wurde geändert',
        error: 'Passwort konnte nicht geändert werden',
        replaces: 'Ein neues Passwort ersetzt das aktuelle: Mail-Apps, die sich mit dem alten anmelden, brauchen dann das neue.',
        requested: 'Lege hier das Passwort für dieses Postfach fest. Du setzt es selbst im Control Panel, es geht also nie über eine verbundene Anwendung.',
        currentRequired: 'Gib dein aktuelles Passwort ein.',
        signInAgain: 'Melde dich mit deinem neuen Passwort erneut an.'
      },
      alias: {
        title: 'Aliase',
        empty: 'Keine Aliase vorhanden',
        placeholder: 'Alias-Name',
        success: 'Alias wurde erstellt',
        deleteSuccess: 'Alias wurde gelöscht',
        error: 'Alias konnte nicht erstellt werden',
        deleteError: 'Alias konnte nicht gelöscht werden'
      }
    },
    vacation: {
      title: 'Abwesenheitsnotiz',
      description: 'Automatische Antwort bei Abwesenheit konfigurieren',
      enabled: 'Abwesenheitsnotiz aktiviert',
      disabled: 'Abwesenheitsnotiz deaktiviert',
      subject: 'Betreff',
      subjectPlaceholder: 'Abwesend bis...',
      message: 'Nachricht',
      messagePlaceholder: 'Ich bin derzeit nicht erreichbar...',
      from: 'Von',
      to: 'Bis',
      save: 'Speichern',
      saving: 'Wird gespeichert...',
      success: 'Abwesenheitsnotiz wurde gespeichert',
      error: 'Abwesenheitsnotiz konnte nicht gespeichert werden',
      loadError: 'Die Abwesenheitsnotiz konnte nicht geladen werden. Versuche es erneut, bevor du sie änderst.'
    },
    identities: {
      title: 'Absender-Identitäten',
      description: 'Zusätzliche E-Mail-Adressen von denen gesendet werden kann',
      add: 'Identität hinzufügen',
      empty: {
        title: 'Keine Identitäten',
        description: 'Füge zusätzliche Absenderadressen hinzu.'
      },
      table: {
        email: 'E-Mail',
        name: 'Name',
        primary: 'Primär',
        verified: 'Verifiziert',
        actions: 'Aktionen'
      },
      addModal: {
        title: 'Identität hinzufügen',
        email: 'E-Mail-Adresse',
        emailPlaceholder: "alias{'@'}domain.de",
        name: 'Anzeigename',
        namePlaceholder: 'Max Mustermann',
        cancel: 'Abbrechen',
        add: 'Hinzufügen',
        adding: 'Wird hinzugefügt...',
        success: 'Identität wurde hinzugefügt',
        error: 'Identität konnte nicht hinzugefügt werden'
      },
      delete: {
        title: 'Identität entfernen',
        message: 'Möchtest du diese Identität wirklich entfernen?',
        cancel: 'Abbrechen',
        confirm: 'Entfernen',
        success: 'Identität wurde entfernt',
        error: 'Identität konnte nicht entfernt werden'
      }
    },
    appPasswords: {
      title: 'App-Passwörter',
      description: 'Separate Passwörter für E-Mail-Apps und externe Dienste',
      usage: 'Ein App-Passwort ersetzt in einem E-Mail-Programm das Passwort des Postfachs, der Benutzername bleibt die volle E-Mail-Adresse. Es gilt nur für E-Mail-Programme, nicht für die Anmeldung hier. Änderst du das Passwort des Postfachs, werden alle App-Passwörter ungültig. Ist eines in fremde Hände geraten, ändere das Passwort des Postfachs, statt es nur zu löschen.',
      limitReached: 'Ein Postfach kann höchstens fünf App-Passwörter haben. Lösche eines, das du nicht mehr brauchst.',
      add: 'App-Passwort erstellen',
      empty: {
        title: 'Keine App-Passwörter',
        description: 'Erstelle ein App-Passwort für E-Mail-Clients.'
      },
      table: {
        name: 'Name',
        created: 'Erstellt',
        lastUsed: 'Zuletzt verwendet',
        actions: 'Aktionen'
      },
      never: 'Nie',
      createModal: {
        title: 'App-Passwort erstellen',
        name: 'Name',
        namePlaceholder: 'z.B. iPhone Mail',
        nameHint: 'Ein Name um dieses Passwort zu identifizieren',
        cancel: 'Abbrechen',
        create: 'Erstellen',
        creating: 'Wird erstellt...',
        success: 'App-Passwort wurde erstellt',
        error: 'App-Passwort konnte nicht erstellt werden',
        result: {
          title: 'App-Passwort erstellt',
          message: 'Kopiere dieses Passwort jetzt. Es wird nicht erneut angezeigt.',
          password: 'Passwort',
          copy: 'Kopieren',
          copied: 'Kopiert',
          done: 'Fertig'
        }
      },
      delete: {
        title: 'App-Passwort löschen',
        message: 'Möchtest du dieses App-Passwort wirklich löschen? Apps, die es verwenden, können sich dann nicht mehr anmelden.',
        cancel: 'Abbrechen',
        confirm: 'Löschen',
        success: 'App-Passwort wurde gelöscht',
        error: 'App-Passwort konnte nicht gelöscht werden'
      }
    },
    history: {
      title: 'Anmeldeverlauf',
      description: 'Letzte Anmeldungen an diesem Postfach',
      empty: {
        title: 'Keine Anmeldungen',
        description: 'Es wurden noch keine Anmeldungen aufgezeichnet.'
      },
      table: {
        time: 'Zeitpunkt',
        ip: 'IP-Adresse',
        protocol: 'Protokoll',
        status: 'Status',
        country: 'Land'
      },
      protocols: {
        imap: 'IMAP',
        smtp: 'SMTP',
        pop3: 'POP3',
        jmap: 'JMAP',
        http: 'Webmail',
        webmail: 'Webmail'
      },
      status: {
        success: 'Erfolgreich',
        failed: 'Fehlgeschlagen'
      }
    }
  },

  quota: {
    unlimited: 'Unbegrenzt',
    used: 'Verwendet',
    free: 'Frei'
  },

  webmail: {
    login: {
      title: 'Webmail Login',
      subtitle: 'Melde dich mit deinem E-Mail-Konto an',
      email: 'E-Mail-Adresse',
      emailPlaceholder: "benutzer{'@'}domain.de",
      password: 'Passwort',
      passwordPlaceholder: 'Passwort eingeben',
      submit: 'Anmelden',
      loggingIn: 'Wird angemeldet...',
      error: 'Anmeldung fehlgeschlagen',
      invalidCredentials: 'E-Mail oder Passwort falsch'
    },
    dashboard: {
      title: 'Postfach',
      logout: 'Abmelden',
      tabs: {
        overview: 'Übersicht',
        vacation: 'Abwesenheit',
        identities: 'Identitäten',
        appPasswords: 'App-Passwörter',
        history: 'Verlauf',
        settings: 'Einstellungen'
      },
      settings: {
        title: 'Verbindungseinstellungen',
        description: 'IMAP und SMTP Server-Informationen für E-Mail-Clients'
      }
    }
  },

  admin: {
    title: 'E-Mail-Verwaltung',
    nav: {
      overview: 'Übersicht',
      accounts: 'Konten',
      server: 'Server',
      messages: 'Nachrichten',
      sendLimits: 'Versandlimits'
    },
    sendLimits: {
      title: 'Versandlimits',
      subtitle: 'Anfragen zur vorzeitigen Aufhebung prüfen und Konten drosseln',
      empty: 'Keine Einträge für diesen Filter.',
      loadError: 'Liste konnte nicht geladen werden',
      actionError: 'Aktion fehlgeschlagen',
      throttled: 'Gedrosselt',
      days: '{n} Tage',
      affected: '{count} Postfächer betroffen',
      syncFailed: 'Mailserver nicht aktualisiert',
      syncFailedHint:
        'Die Änderung ist gespeichert, konnte aber nicht an den Mailserver übertragen werden. Bitte den Task mail-guard-sync ausführen.',
      noSendersAffected: 'Drosselung hat kein Postfach erreicht',
      noSendersAffectedHint:
        'Für dieses Konto wurde kein Postfach gefunden, das die Drosselung erfasst. Bei akutem Missbrauch stattdessen das Konto deaktivieren.',
      approveBlocked:
        'Freigabe nicht möglich, solange eine Drosselung aktiv ist. Zuerst die Drosselung aufheben.',
      forcedReason: 'Grund der Drosselung: {reason}',
      confirmFor: 'Konto: {email}',
      noteLabel: 'Begründung',
      notePlaceholder: 'Mindestens 10 Zeichen',
      filter: {
        label: 'Filter',
        pending: 'Offen',
        throttled: 'Gedrosselt',
        approved: 'Freigegeben',
        denied: 'Abgelehnt',
        all: 'Alle'
      },
      signals: {
        age: 'Kontoalter',
        mailboxes: 'Postfächer',
        outbound: 'Versand 7 Tage',
        verified: 'E-Mail bestätigt',
        payment: 'Zahlungsmittel',
        requested: 'Beantragt'
      },
      actions: {
        approve: 'Freigeben',
        approveTitle: 'Versandlimit freigeben',
        approveSuccess: 'Versandlimit freigegeben',
        deny: 'Ablehnen',
        denyTitle: 'Anfrage ablehnen',
        denySuccess: 'Anfrage abgelehnt',
        restrict: 'Drosseln',
        restrictTitle: 'Konto drosseln',
        restrictSuccess: 'Konto gedrosselt',
        unrestrict: 'Drosselung aufheben',
        unrestrictTitle: 'Drosselung aufheben',
        unrestrictSuccess: 'Drosselung aufgehoben',
        withdraw: 'Freigabe zurücknehmen',
        withdrawTitle: 'Freigabe zurücknehmen',
        withdrawSuccess: 'Freigabe zurückgenommen'
      }
    },
    overview: {
      title: 'E-Mail Übersicht',
      health: {
        title: 'Serverstatus',
        healthy: 'Gesund',
        degraded: 'Eingeschränkt',
        unhealthy: 'Nicht erreichbar',
        unknown: 'Unbekannt'
      },
      stats: {
        messagesIn: 'Empfangene Nachrichten',
        messagesOut: 'Gesendete Nachrichten',
        spamRejected: 'Spam abgelehnt',
        authFailures: 'Fehlgeschlagene Anmeldungen'
      },
      queue: {
        title: 'Warteschlange',
        pending: 'Ausstehende Nachrichten',
        empty: 'Warteschlange ist leer'
      }
    },
    accounts: {
      title: 'Alle E-Mail-Konten',
      subtitle: 'Konten über alle Domains verwalten',
      table: {
        email: 'E-Mail',
        domain: 'Domain',
        type: 'Typ',
        usage: 'Speicher',
        status: 'Status',
        lastLogin: 'Letzte Anmeldung',
        owner: 'Besitzer',
        actions: 'Aktionen'
      }
    },
    server: {
      title: 'Server-Status',
      health: {
        title: 'Komponenten',
        stalwart: 'Mailserver',
        queue: 'Warteschlange',
        reachable: 'Erreichbar',
        notReachable: 'Nicht erreichbar',
        healthy: 'Gesund',
        unhealthy: 'Problem'
      },
      queue: {
        title: 'Warteschlange',
        table: {
          from: 'Von',
          to: 'An',
          subject: 'Betreff',
          retries: 'Versuche',
          nextRetry: 'Nächster Versuch',
          queued: 'Eingereiht'
        }
      },
      stats: {
        title: 'Statistiken',
        period: 'Zeitraum',
        total: 'Gesamt',
        perDomain: 'Pro Domain'
      }
    },
    messages: {
      title: 'Nachrichtenprotokoll',
      inbound: 'Eingehend',
      outbound: 'Ausgehend',
      searchPlaceholder: 'Absender, Empfänger oder Betreff...',
      time: 'Zeit',
      sender: 'Absender',
      recipient: 'Empfänger',
      subject: 'Betreff',
      size: 'Größe',
      empty: 'Keine Nachrichten aufgezeichnet.'
    },
    dashboard: {
      totalAccounts: 'Konten gesamt',
      activeAccounts: 'Aktiv',
      storage: 'Speicher',
      messageFlow: 'Nachrichtenfluss',
      spamRate: 'Spam-Rate',
      period: {
        day: 'Tag',
        week: 'Woche',
        month: 'Monat'
      }
    }
  },

  mailboxDelegation: {
    title: 'Postfach-Delegierte',
    subtitle: 'Postfachbenutzern Verwaltungszugriff über das Webmail-Portal gewähren',
    addDelegate: 'Delegierten hinzufügen',
    empty: 'Keine Postfach-Delegierten konfiguriert',
    emptyDescription: 'Füge einen Delegierten hinzu, um einem Postfachbenutzer Verwaltungszugriff auf diese Domain über das Webmail-Portal zu gewähren.',
    never: 'Kein Ablaufdatum',
    permissionGroups: {
      mailbox: 'Postfächer',
      mailinglist: 'Mailinglisten'
    },
    permissionLabels: {
      'mailbox:read': 'Anzeigen',
      'mailbox:write': 'Erstellen & Bearbeiten',
      'mailbox:delete': 'Löschen',
      'mailinglist:read': 'Anzeigen',
      'mailinglist:write': 'Erstellen & Bearbeiten'
    },
    add: {
      title: 'Delegierten hinzufügen',
      subtitle: 'Einem Postfachbenutzer Verwaltungsberechtigungen erteilen',
      email: 'E-Mail',
      emailPlaceholder: "benutzer{'@'}domain.de",
      emailHint: 'Die Postfach-E-Mail-Adresse des Benutzers, der delegiert werden soll',
      permissions: 'Berechtigungen',
      permissionsHint: 'Wähle die Berechtigungen, die der Delegierte haben soll',
      expiry: 'Ablaufdatum',
      noExpiry: 'Kein Ablaufdatum',
      expiryHint: 'Optional ein Ablaufdatum für diese Delegation festlegen'
    },
    edit: {
      title: 'Delegierten bearbeiten',
      subtitle: 'Berechtigungen und Ablaufdatum des Delegierten aktualisieren'
    },
    delete: {
      title: 'Delegierten entfernen',
      confirmText: 'Entfernen',
      warningText: 'Dieser Delegierte verliert sämtlichen Verwaltungszugriff auf diese Domain über das Webmail-Portal.'
    },
    notifications: {
      added: 'Delegierter hinzugefügt',
      addedMessage: '{email} wurde Delegiertenzugriff gewährt',
      accountNotFound: 'Kein Postfachkonto mit dieser E-Mail-Adresse gefunden',
      alreadyDelegate: 'Dieser Postfachbenutzer ist bereits ein Delegierter',
      updated: 'Delegierter aktualisiert',
      updatedMessage: 'Berechtigungen des Delegierten wurden aktualisiert',
      deleted: 'Delegierter entfernt',
      deletedMessage: '{email} wurde als Delegierter entfernt'
    }
  },
  billing: {
    activateTitle: 'E-Mail Hosting aktivieren',
    activateDescription: 'Bis zu 1.000 Postfächer auf dieser Domain. DKIM, SPF und DMARC automatisch konfiguriert.',
    activate: 'Aktivieren',
    activated: 'E-Mail aktiviert',
    deactivated: 'E-Mail-Hosting gekündigt',
    perMonth: '€/Monat',
    usageTitle: 'E-Mail Nutzung',
    storage: 'Speicher',
    outbound: 'Ausgehende Nachrichten (Monat)',
    projectedOverage: 'Voraussichtliche Zusatzkosten',
    net: 'netto',
    month: 'Monat',
    includedInHosting: 'Im Hosting inklusive',
    grandfathered: 'Bestandskunde',
    deactivate: 'E-Mail-Hosting sofort kündigen',
    deactivateWarning: 'Die E-Mail-Zustellung für diese Domain wird sofort beendet, der laufende Abrechnungszeitraum wird nicht erstattet. Deine Postfächer und E-Mails bleiben gespeichert. Für eine Kündigung zum Laufzeitende nutze Pakete → Kündigen.',
    confirmDeactivate: 'Sofort kündigen',
    deactivateGrandfathered: 'E-Mail-Hosting beenden',
    deactivateGrandfatheredWarning: 'Die E-Mail-Zustellung für diese Domain wird sofort beendet. Deine Postfächer und E-Mails bleiben gespeichert. Dein kostenloser Bestandskunden-Tarif entfällt damit dauerhaft: eine spätere Reaktivierung läuft über das kostenpflichtige E-Mail-Hosting zum dann gültigen Preis.',
    confirmDeactivateGrandfathered: 'E-Mail beenden',
    includedInHostingHint: 'E-Mail ist in deinem Hosting-Paket enthalten und hat keinen eigenen Vertrag. Solange das Paket läuft und die Domain mit ihm verknüpft ist, bleibt E-Mail für diese Domain aktiv. Das Paket selbst kündigst du unter Pakete.',
    endsOn: 'Gekündigt zum {date}. Bis dahin läuft E-Mail normal weiter, danach wird sie für diese Domain abgeschaltet. Deine Postfächer und E-Mails bleiben gespeichert.',
    deactivateNoticeWarning: 'Dein E-Mail-Hosting ist bereits zum {date} gekündigt. Beendest du es jetzt, stoppt die Zustellung sofort statt am {date}, und für die restliche Zeit gibt es keine Erstattung. Deine Postfächer und E-Mails bleiben gespeichert.',
    takeoverNote: 'Diese Domain ist jetzt mit einem Hosting-Paket verknüpft, in dem E-Mail enthalten ist. Dein kostenpflichtiges E-Mail-Hosting wird deshalb in Kürze automatisch beendet, und die nicht genutzten Tage werden anteilig erstattet.',
    reactivate: 'E-Mail wieder aktivieren',
    customerHoldTitle: 'E-Mail ist abgeschaltet',
    customerHoldDescription: 'Du hast E-Mail für diese Domain abgeschaltet. Deine Postfächer und E-Mails sind noch gespeichert und werden mit dem Wiedereinschalten wieder aktiv. Zusätzliche Kosten entstehen dabei nicht.',
    pendingTitle: 'E-Mail ist noch abgeschaltet',
    pendingDescription: 'Die Domain ist wieder für E-Mail berechtigt. Deine Postfächer werden innerhalb einer Stunde automatisch wieder eingeschaltet, oder du schaltest sie jetzt ein.',
    switchOnNow: 'E-Mail jetzt einschalten',
    paidHoldNote: 'E-Mail für diese Domain ist abgeschaltet, dein E-Mail-Hosting wird aber weiter berechnet. Schalte E-Mail wieder ein oder beende das E-Mail-Hosting unten.',
    customerHoldNote: 'Du hast E-Mail für diese Domain abgeschaltet. Deine Postfächer und E-Mails sind noch gespeichert.',
    noEntitlementNote: 'E-Mail für diese Domain wurde abgeschaltet, weil kein E-Mail-Hosting mehr besteht. Deine Postfächer und E-Mails sind noch gespeichert und werden wieder eingeschaltet, sobald E-Mail-Hosting für die Domain besteht.',
    domainDeletedTitle: 'Domain gelöscht',
    domainDeletedDescription: 'E-Mail ist abgeschaltet, weil die Domain gelöscht wurde. Stelle die Domain wieder her, dann kannst du E-Mail wieder nutzen. Deine Postfächer und E-Mails sind noch gespeichert.',
    goToDomain: 'Zur Domain',
    domainSuspendedTitle: 'Domain gesperrt',
    domainSuspendedDescription: 'Die Domain ist gesperrt, deshalb ist E-Mail vorübergehend abgeschaltet. Sobald die Sperre aufgehoben ist und E-Mail-Hosting für die Domain besteht, wird sie wieder eingeschaltet. Deine Postfächer und E-Mails bleiben gespeichert.',
    adminHoldTitle: 'E-Mail gesperrt',
    adminHoldDescription: 'E-Mail für diese Domain wurde von uns gesperrt. Bitte wende dich an den Support.',
    errors: {
      takeoverPending: 'Dein E-Mail-Hosting wird gerade vom Hosting-Paket übernommen und endet automatisch mit anteiliger Erstattung. Du musst nichts kündigen.',
      adminHold: 'E-Mail für diese Domain wurde von uns gesperrt. Bitte wende dich an den Support.',
      ownerOnly: 'Nur der Inhaber der Domain kann E-Mail für sie aktivieren oder beenden.',
      domainSuspended: 'Die Domain ist gesperrt. E-Mail lässt sich erst wieder aktivieren, wenn die Sperre aufgehoben ist.',
      domainDeleted: 'Die Domain wurde gelöscht. Stelle sie zuerst wieder her, dann kannst du E-Mail aktivieren.',
      reenableFailed: 'E-Mail konnte nicht vollständig eingeschaltet werden. Bitte versuche es in ein paar Minuten erneut.',
      stripeUnavailable: 'Die Zahlungsabwicklung war gerade nicht erreichbar. Bitte versuche es in ein paar Minuten erneut.'
    }
  },

  errorCodes: {
    protectedAccount: 'Dieses Postfach wird von uns verwaltet und lässt sich hier nicht ändern. Wende dich an den Support, wenn du eine Änderung brauchst.',
    ownerMismatch: 'Die Adresse und das Postfach oder der Verteiler, zu dem sie gehört, gehören verschiedenen Kunden. Das lässt sich hier nicht verbinden.',
    aliasTargetFixed: 'Diese Adresse gehört fest zu ihrem Postfach oder Verteiler. Ihr Ziel lässt sich nicht ändern.',
    externalMemberLimit: 'Ein Verteiler oder eine Weiterleitung darf an höchstens 100 externe Adressen zustellen.',
    invalidSharedMember: 'Mitglieder eines geteilten Postfachs müssen Postfächer auf derselben Domain sein.',
    mailServerFailed: 'Der Mailserver hat die Änderung nicht bestätigt. Versuche es in ein paar Minuten erneut.',
    filterBusy: 'Gerade läuft schon eine andere Änderung an den Filtern dieses Postfachs. Versuche es gleich noch einmal.',
    addressExists: 'Diese Adresse gibt es bereits, eventuell ist sie gerade abgeschaltet.',
    identityOff: 'Diese Adresse ist bereits eine Identität dieses Postfachs, aber gerade abgeschaltet. Sie wird wieder aktiv, sobald E-Mail auf ihrer Domain eingeschaltet ist.',
    rateLimited: 'Zu viele Änderungen in kurzer Zeit. Warte eine Minute und versuche es dann erneut.',
    currentPasswordWrong: 'Das aktuelle Passwort stimmt nicht.',
    credentialRateLimited: 'Zu viele Versuche. Versuche es in einer Viertelstunde erneut.'
  },

  entitlement: {
    goToActivation: 'Zur E-Mail-Aktivierung',
    owner: {
      notEntitled: 'Für diese Domain ist kein E-Mail-Hosting aktiv. Aktiviere E-Mail für die Domain, dann kannst du Adressen anlegen und einschalten.',
      disabled: 'E-Mail ist für diese Domain abgeschaltet. Schalte E-Mail für die Domain wieder ein, dann kannst du Adressen anlegen und einschalten.',
      adminHold: 'E-Mail für diese Domain wurde von uns gesperrt. Bitte wende dich an den Support.',
      unverified: 'Bestätige zuerst, dass dir die Domain gehört: Lege den TXT-Eintrag _itsh-mail aus der DNS-Einrichtung an.'
    },
    delegate: {
      notEntitled: 'Für diese Domain ist kein E-Mail-Hosting aktiv. Der Inhaber der Domain muss E-Mail erst aktivieren.',
      disabled: 'E-Mail ist für diese Domain abgeschaltet. Der Inhaber der Domain muss E-Mail erst wieder einschalten.',
      adminHold: 'E-Mail für diese Domain ist gesperrt. Bitte wende dich an den Inhaber der Domain.',
      unverified: 'Die Domain ist noch nicht bestätigt. Der Inhaber der Domain muss zuerst den TXT-Eintrag _itsh-mail anlegen.'
    }
  },

  addressTaken: {
    mailbox: 'Diese Adresse gehört bereits zu einem Postfach.',
    shared: 'Diese Adresse gehört bereits zu einem geteilten Postfach.',
    alias: 'Diese Adresse gehört bereits zu einem Alias.',
    list: 'Diese Adresse gehört bereits zu einer Mailingliste.',
    switchedOff: 'Auch ausgeschaltet bleibt die Adresse belegt. Lösche den Eintrag, um sie neu zu verwenden.',
    generic: 'Diese Adresse ist bereits vergeben.'
  },

  sendLimit: {
    title: 'Versandlimit für neue Konten',
    description:
      'In den ersten {days} Tagen ab Registrierung deines Kundenkontos gelten {hourly} Nachrichten pro Stunde und {daily} pro Tag je Postfach.',
    reassurance:
      'Nachrichten darüber hinaus gehen nicht verloren. Sie werden vorübergehend abgewiesen und bleiben in deinem E-Mail-Programm. Je nach Programm wird die Zustellung automatisch wiederholt, sonst sendest du sie erneut.',
    autoLift: 'Am {date} enden die reduzierten Limits automatisch. Du musst nichts tun.',
    daysLeft: 'noch {n} Tag | noch {n} Tage',
    statusLabel: {
      none: 'Keine Anfrage',
      pending: 'Offen',
      approved: 'Freigegeben',
      denied: 'Abgelehnt'
    },
    request: {
      button: 'Vorzeitige Aufhebung beantragen',
      dialogTitle: 'Aufhebung des Versandlimits beantragen',
      dialogDescription:
        'Wir heben die Beschränkung vorzeitig auf, sofern keine Anhaltspunkte für Missbrauch vorliegen. Ein Mitarbeiter prüft deine Anfrage.',
      reasonLabel: 'Grund',
      reasonPlaceholder: 'z. B. Migration bestehender Postfächer von einem anderen Anbieter',
      submit: 'Anfrage senden',
      success: 'Anfrage gesendet',
      error: 'Anfrage konnte nicht gesendet werden'
    },
    status: {
      pending: 'Deine Anfrage vom {date} wird geprüft.',
      pendingShort: 'Wir melden uns, sobald die Prüfung abgeschlossen ist.',
      approved: 'Die Beschränkung wurde aufgehoben. Es gelten die regulären Versandlimits.',
      denied: 'Deine Anfrage wurde abgelehnt.',
      deniedReason: 'Begründung: {reason}',
      throttled:
        'Für dein Konto gilt derzeit ein reduziertes Versandlimit, das von uns gesetzt wurde.',
      throttledHint: 'Bitte wende dich an den Support, wenn du dazu Fragen hast.'
    }
  },

  filters: {
    title: 'Sieve-Filter',
    description: 'Eingehende Nachrichten automatisch sortieren, weiterleiten oder kennzeichnen.',
    create: 'Filter anlegen',
    createTitle: 'Neuen Filter anlegen',
    editTitle: 'Filter bearbeiten',
    enabled: 'Aktiv',
    disabled: 'Deaktiviert',
    deleted: 'Filter gelöscht',
    savedCreate: 'Filter angelegt',
    savedEdit: 'Filter gespeichert',
    deleteTitle: 'Filter löschen?',
    deleteConfirm: 'Filter „{name}" wird unwiderruflich entfernt. Bestehende E-Mails bleiben erhalten.',
    moveUp: 'Nach oben',
    moveDown: 'Nach unten',
    fieldNameLabel: 'Filtername',
    conditions: 'Bedingungen',
    actions: 'Aktionen',
    addCondition: 'Bedingung hinzufügen',
    addAction: 'Aktion hinzufügen',
    noConditions: 'Keine Bedingungen — Aktionen werden bei jeder Nachricht ausgeführt.',
    stopOnMatch: 'Weitere Filter überspringen, wenn dieser greift',
    valuePlaceholder: 'Wert',
    sizePlaceholder: 'z. B. 5M oder 1024',
    headerNamePlaceholder: 'Header-Name (z. B. List-Id)',
    folderPlaceholder: 'Ordnername (z. B. GitHub)',
    forwardPlaceholder: "weiterleiten{'@'}example.com",
    rejectReasonPlaceholder: 'Begründung der Ablehnung',
    createFolder: 'Ordner ggf. erstellen',
    negate: 'Bedingung umkehren',
    rawTitle: 'Sieve-Quellcode',
    rawHint: 'Direkt Sieve schreiben (RFC 5228). Wird beim Speichern serverseitig validiert.',
    preview: 'Generiertes Sieve-Skript',
    previewPlaceholder: 'Bedingung oder Aktion ausfüllen, um die Vorschau zu sehen.',
    validating: 'wird geprüft …',
    validOk: 'Filter ist gültig',
    previewUnavailable: 'Die Prüfung ist gerade nicht möglich. Beim Speichern wird der Filter trotzdem geprüft.',
    format: 'Formatieren',
    formatTitle: 'Skript formatieren (Shift+Alt+F)',
    wasmLoading: 'Lokaler Sieve-Validator wird geladen …',
    wasmReady: 'Lokale Syntaxprüfung aktiv',
    wasmUnavailable: 'Lokale Syntaxprüfung nicht verfügbar — Server prüft beim Speichern.',
    mode: {
      builder: 'Editor',
      raw: 'Quellcode'
    },
    match: {
      all: 'Alle',
      any: 'Mindestens eine'
    },
    fields: {
      from: 'Absender (From)',
      to: 'Empfänger (To)',
      cc: 'Kopie (Cc)',
      subject: 'Betreff',
      header: 'Beliebiger Header',
      body: 'Nachrichtentext',
      size: 'Größe',
      'envelope-from': 'Envelope-Absender',
      'envelope-to': 'Envelope-Empfänger'
    },
    ops: {
      contains: 'enthält',
      is: 'ist gleich',
      matches: 'Muster (Glob)',
      regex: 'regex',
      over: 'größer als',
      under: 'kleiner als'
    },
    actionTypes: {
      fileinto: 'In Ordner verschieben',
      'copy-fileinto': 'Kopie in Ordner ablegen',
      'mark-read': 'Als gelesen markieren',
      flag: 'Markierung setzen',
      forward: 'Weiterleiten an',
      discard: 'Verwerfen',
      reject: 'Ablehnen mit Grund',
      stop: 'Verarbeitung stoppen'
    },
    summary: {
      raw: 'Eigener Sieve-Quellcode',
      builder: '{conds} Bedingung(en) ({match}), {acts} Aktion(en)'
    },
    empty: {
      title: 'Noch keine Filter angelegt',
      hint: 'Lege deinen ersten Filter an, um Nachrichten automatisch zu sortieren.'
    }
  }
} as const
